<section>
    @if (!encodingJob) {
    <admin-media-asset-player [src]="mediaAssetSrc" [token]="token()"> </admin-media-asset-player>
    } @else {
    <admin-encoding-status [encodingJob]="encodingJob"></admin-encoding-status>
    }
</section>
